
import {
  computed, defineComponent, provide, ref,
} from 'vue';
import { useStore } from 'vuex';
import { userClient } from '@/apis';
import { useProcessAvatar } from '@/composables';
import { useRouter } from 'vue-router';
import axios from 'axios';
import {
  RatingList, CommentList, LessonList, CommonList,
} from './components';
import { CommonTabType } from './types';

type TabType = '点评' | '回复' | '课程' | CommonTabType;
interface UserProfile {
  avatar: string;
  bio: string;
  name: string;
  nickname: string;
  fans: number;
  watchers: number;
  watchees: number;
}

export default defineComponent({
  components: {
    RatingList,
    CommentList,
    LessonList,
    CommonList,
  },
  props: {
    // 访问的用户 ID
    userId: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const currentUser = computed(() => store.state.user);
    const userLoggedIn = computed(() => store.getters.userLoggedIn);
    const isCurrentUser = () => userLoggedIn.value && (props.userId === currentUser.value.id || props.userId === '');
    const setUserProfile = (profile: UserProfile) => store.commit('setUserProfile', profile);

    const logout = () => {
      if (userLoggedIn.value) {
        store.commit('logout');
        router.replace({ name: 'Timetable' });
      } else {
        store.commit('logout');
        router.replace({ name: 'Login', query: { redirect: '/user' } });
      }
    };

    const userProfile = ref<UserProfile>({
      avatar: '',
      bio: '',
      name: '',
      nickname: '',
      fans: 0,
      watchers: 0,
      watchees: 0,
    });

    // 读取用户信息
    if (isCurrentUser()) {
      userProfile.value = {
        avatar: currentUser.value.avatar,
        bio: currentUser.value.bio,
        name: currentUser.value.name,
        nickname: currentUser.value.nickname,
        fans: currentUser.value.fans,
        watchers: currentUser.value.watchers,
        watchees: currentUser.value.watchees,
      };
    }
    userClient
      .getUserInfo({ userId: props.userId || currentUser.value.id })
      .then((resp) => {
        userProfile.value = resp;
        if (isCurrentUser()) {
          setUserProfile(resp);
        }
      })
      .catch(() => {
        // 返回到上一页面
        router.go(-1);
      });

    provide<string>('userId', props.userId || currentUser.value.id);

    const { processAvatar } = useProcessAvatar();

    const activeTab = ref<TabType>('点评');

    // 判断是否显示 About 入口小红点的逻辑
    /** 是否显示 About 入口小红点 */
    const isAboutBadgeVisible = ref(false);

    /** 最近一次看过的更新日志日期 */
    const lastSawChangeLogDate = computed(() => store.state.lastSawChangeLogDate);

    axios.get<{ date: string }[]>('changeLog.json')
      .then(({ data }) => {
        /** 最新的更新日志日期 */
        const latestDate = data.map((d) => d.date).sort((a, b) => (a < b ? 1 : -1))[0];
        if (latestDate !== lastSawChangeLogDate.value) {
          isAboutBadgeVisible.value = true;
        }
      });

    return {
      processAvatar,
      userProfile,
      activeTab,
      isCurrentUser,
      logout,
      isAboutBadgeVisible,
    };
  },
});
